let messages = null

export const getTranslationMessages = () => messages

export const setTranslationMessages = (nextMessages) => {
	messages = nextMessages
}
